import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, type LazyComponent } from 'owa-bundling';
import type { NpmMeControlProps } from './components/NpmMeControl';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OwaNpmMeControl" */ './lazyIndex'),
    { name: 'OwaNpmMeControl' }
);

export const LazyNpmMeControl: LazyComponent<NpmMeControlProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.NpmMeControl);
